"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSimpleFetchError = exports.SimpleFetchError = void 0;
class SimpleFetchError extends Error {
    constructor(baseURL, url, response) {
        super(`Failed to get response from ${new URL(url, baseURL).toString()}`);
        this.baseURL = baseURL;
        this.url = url;
        this.response = response;
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, SimpleFetchError.prototype);
    }
}
exports.SimpleFetchError = SimpleFetchError;
function isSimpleFetchError(payload) {
    return payload instanceof SimpleFetchError;
}
exports.isSimpleFetchError = isSimpleFetchError;
